import loadBasketModule from './modules/Basket.module';
const loadDeliveryConditionsBannerModule = () => ({
    hasRouter: false,
    modules: [loadBasketModule()],
});
export default loadDeliveryConditionsBannerModule;
